(function () {
  const PADDLE_TOKEN = 'live_26c883fa661139b06f04aab638c';

  const PRODUCT_PRICES = {
    'PRIME ADAM MOST WANTED': 'pri_01m0k3w5h30ec0ajqjbab2ts63',
    'THE STANDARD SYSTEM ZERO': 'pri_01m0k48e6v3f6raamjd87a6zgt'
  };

  function initializePaddle() {
    if (!window.Paddle) {
      console.error('Paddle.js has not loaded.');
      return false;
    }

    if (!window.__paddleInitialized) {
      Paddle.Initialize({
        token: PADDLE_TOKEN
      });

      window.__paddleInitialized = true;
    }

    return true;
  }

  async function openPaddleCheckout() {
    if (!initializePaddle()) {
      return;
    }

    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Unable to read Shopify cart.');
      }

      const cart = await response.json();

      const items = cart.items
        .map((item) => {
          const priceId = PRODUCT_PRICES[item.product_title];

          if (!priceId) {
            return null;
          }

          return {
            priceId: priceId,
            quantity: item.quantity
          };
        })
        .filter(Boolean);

      if (!items.length) {
        console.error('No supported Paddle product was found in the Shopify cart.');
        return;
      }

      Paddle.Checkout.open({
    items: items,
    settings: {
        successUrl: "https://looksadvanced.com/pages/purchase-complete"
    }
});
    } catch (error) {
      console.error('Paddle checkout error:', error);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const checkoutButton = event.target.closest(
        'button#checkout[name="checkout"][form="cart"]'
      );

      if (!checkoutButton) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openPaddleCheckout();
    },
    true
  );
})();